module.exports = {"widgetStyleData":{"styleConfig":{"diameter":48}}}